// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__19WmY","overflowing":"ReadFullNote_overflowing__i26N1"};